import GradientCapsdark from "../../Assets/Images/about-us-section-two-g1-new.png";
import GradientCapslight from "../../Assets/Images/about-us-section-two-g2-new.png";
import GradientCapslightest from "../../Assets/Images/about-us-section-two-g3-new.png";

const CapsuleImageVertical = ({ image }) => {
  return (
    <>
      <div className="flex items-center justify-center relative sm:aspect-[5/4] lg:aspect-[3/4] w-full">
        <div className=" inset-0 middivimg">
          <div className="relative flex  items-center justify-center health-insurance-image-vs max-w-[316px] lg:scale-[0.85] [@media(min-width:1920px)]:scale-100 origin-center">
            <img
              src={image}
              alt="Smiling man"
              className="z-[1] animate__animated animate__fadeIn"
            />
            {/* Decorative capsules */}
            <img
              src={GradientCapsdark}
              alt=""
              className="z-[4] absolute top-0 animate__animated animate__fadeInRight"
            />
            <img
              src={GradientCapslight}
              alt=""
              className="z-[3] absolute top-0 animate__animated animate__fadeInDown"
            />
            <img
              src={GradientCapslightest}
              alt=""
              className="z-[3] absolute top-0 animate__animated animate__fadeInUp"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CapsuleImageVertical;
